module.exports = __webpack_public_path__ + "img/chicken_animal_4448.83f56007.png";